export default "__VITE_ASSET__WUbTy7ob__"